import axios from 'axios';

// Align with other services so deployed bundles read REACT_APP_API_URL.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const REFUNDS_API_PATH = '/api/refunds';
const SALES_API_PATH = '/api/sales';

const processRefund = async (refundData) => {
  const response = await axios.post(`${API_BASE_URL}${REFUNDS_API_PATH}`, refundData);
  return response.data.data;
};

const findSaleByReceipt = async (receiptNumber, storeId) => {
  const response = await axios.get(`${API_BASE_URL}${SALES_API_PATH}/receipt/${receiptNumber}`, {
    params: { storeId },
  });
  return response.data.data;
};

const getRefundsForSale = async (saleId, storeId) => {
  const response = await axios.get(`${API_BASE_URL}${REFUNDS_API_PATH}/sale/${saleId}`, {
    params: { storeId },
  });
  return response.data.data;
};

const previewRefund = async (refundData) => {
  const response = await axios.post(`${API_BASE_URL}${REFUNDS_API_PATH}/preview`, refundData);
  return response.data.data;
};

const refundsService = {
  processRefund,
  findSaleByReceipt,
  getRefundsForSale,
  previewRefund,
};

export default refundsService;
